import { clone } from "lodash";
import WSProductDisplay, { WSProductDisplayType } from "./WSProductDisplay";
import WSMediaRestriction, { WSMediaRestrictionType } from "./WSMediaRestriction";

// 2.7.72.3 WSMediaProduct

export default class WSMediaProduct {
	constructor({
		mediaSKU,
		mediaTypeId,
		mediaTypeName = null,
		mediaGroupId = null,
		mediaName = null,
		mediaShortName = null,
		mediaLongName = null,
		mediaFee = null,
		mediaDepositFee = null,
		mediaReplacementFee = null,
		mediaEnablementFee = null,
		riderClassId = null,
		riderClassDescription = null,
		subsystemTokenType = null,
		inventoryPartNumber = null,
		waiveEnableFeeFlag = false,
		isNegativeBalanceTravelAllowed = false,
		writeOffClose = null,
		enablementFeeType = null,
		isNonReloadable = false,
		waiveEnableFeeReasonCode = null,
		display = null,
		mediaRestrictions = null,
	}) {
		/**
		 * @type string(40)
		 * (Required) Media SKU.
		 */
		this.mediaSKU = mediaSKU;

		/**
		 * @type string(40)
		 * (Required) Media Type Id.
		 */
		this.mediaTypeId = mediaTypeId;

		/**
		 * @type string(40)
		 * (Optional) Media Group Id.
		 */
		this.mediaGroupId = mediaGroupId;

		/**
		 * @type string(40)
         * (Required) The type of media to issue.
		 */
		this.mediaTypeName = mediaTypeName;

		/**
		 * @type string(40)
		 * (Optional) Media Name.
		 */
		this.mediaName = mediaName;

		/**
		 * @type string(40)
		 * (Optional) Media Short Name.
		 */
		this.mediaShortName = mediaShortName;

		/**
		 * @type string(40)
		 * (Optional) Media Long Name.
		 */
		this.mediaLongName = mediaLongName;

		/**
		 * @type Int
		 * (Optional) Media Fee.
		 */
		this.mediaFee = mediaFee;

		/**
		 * @type Int
		 * (Optional) Media Deposit Fee.
		 */
		this.mediaDepositFee = mediaDepositFee;

		/**
		 * @type Int
		 * (Optional) Media Replacement Fee.
		 */
		this.mediaReplacementFee = mediaReplacementFee;

		/**
		 * @type Int
		 * (Optional) Media Enablement Fee.
		 */
		this.mediaEnablementFee = mediaEnablementFee;

		/**
		 * @type Int
		 * (Optional) Ride Class ID.
		 */
		this.riderClassId= riderClassId;

		/**
		 * @type String
		 * (Optional) Ride Class Description.
		 */
		this.riderClassDescription = riderClassDescription;

		/**
		 * @type String
		 * (Optional) Subsystem Token Type.
		 */
		this.subsystemTokenType = subsystemTokenType;

		/**
		 * @type boolean
		 * 	(Optional) Indicates if the enablement fee should be waived. Default is false. When this flag is true, the replacement enablement fee is refunded to the travel account stored value.
		 */
		this.waiveEnableFeeFlag	= waiveEnableFeeFlag;

		/**
		 * @type boolean
		 * 	(Optional) True or False based on the additional journey availability
		 */
		this.isNegativeBalanceTravelAllowed	= isNegativeBalanceTravelAllowed;

		/**
		 * @type boolean
		 * 	(Optional) Flag to close the Write Off
		 */
		this.writeOffClose	= writeOffClose;

		/**
		 * @type string
		 * 	(Rquired)  is required in the enablement fee calculation in the case of manual waive off process.
		 * 	 Values of enablement fee type are { "Full" , "Reduced" , " Waived - no negative balance " , " Waived - w/negative balance " }
		 */
		this.enablementFeeType	= enablementFeeType;

		/**
		 * @type boolean
		 * 	(Optional) Flag should be false when reloadable true and flag should be true when reloadable false
		 */
		this.isNonReloadable	= isNonReloadable;

		/**
		 * @type int
		 * 	(Optional) Reason code for waiving the enablement fee.
		 */
		this.waiveEnableFeeReasonCode	= waiveEnableFeeReasonCode;


		/**
		 * @type String
		 */
		this.inventoryPartNumber = inventoryPartNumber;

		/**
		 * @type WSProductDisplay
		 */
		this.display = display;


		/**
		 * @type WSMediaRestriction
		 */
		this.mediaRestrictions = mediaRestrictions;

	}
	static fromBackoffice(data) {
		const result = new WSMediaProduct(data);

		result.display = result.display?.map(group => WSProductDisplay.fromBackoffice(group)) ?? [];
		result.mediaRestrictions = result?.mediaRestrictions?.map(restriction => WSMediaRestriction.fromBackoffice(restriction)) ?? [];

		return result;
	}

	toBackoffice() {
		const result = clone(this);

		result.display = this.display.map(group => group.toBackoffice());
		result.mediaRestrictions = this.mediaRestrictions.map(restriction => restriction.toBackoffice());

		return result;
	}

	toResolver() {
		const forGraphql = clone(this);

		forGraphql.id = forGraphql.mediaSKU;
		forGraphql.display = this.display?.map(group => group.toResolver()) ?? [];
		forGraphql.mediaRestrictions = this.mediaRestrictions?.map(restriction => restriction.toResolver()) ?? [];

		return forGraphql;
	}
}

export const WSMediaProductType = [
	...WSProductDisplayType,
	...WSMediaRestrictionType,
	`
	type WSMediaProduct {
		id: ID!
		mediaSKU: String!
		mediaTypeId: Int!
		mediaTypeName: String
		mediaGroupId: Int
		mediaName: String
		mediaShortName: String
		mediaLongName: String
		mediaFee: Int
		mediaDepositFee: Int
		mediaReplacementFee: Int
		mediaEnablementFee: Int
		riderClassId: Int
		riderClassDescription: String
		subsystemTokenType: String
		inventoryPartNumber: String
		waiveEnableFeeFlag: Boolean
		isNegativeBalanceTravelAllowed: Boolean
		writeOffClose: Boolean
		enablementFeeType: String
		isNonReloadable: Boolean
		waiveEnableFeeReasonCode: String
		mediaRestrictions: [ WSMediaRestriction! ]
		display: [ WSProductDisplay! ]
	}
`,
];
